import Emitter from "es6-event-emitter";
import {
  CLICKED_ABOUT_SETTINGS,
  CLICKED_ACCOUNT_SETTINGS,
  CLICKED_CLOSE_SETTINGS,
  CLICKED_HELP_SETTINGS,
  CLICKED_LANDSCAPE_TOGGLE_SETTINGS,
  CLICKED_READING_MODE_SETTINGS,
  CLICKED_REGIONSELECT_SETTINGS,
  OPENED_SETTINGS,
  REACHED_REDIRECT_LIMIT,
} from "./../../analytics/analyticsevents";
import language from "./../../dictionary";
import setting from "./../../templates/settings/setting.dust";
import APIManager from "./../../utilities/apimanager";
import CookieManager from "./../../utilities/cookiemanager";
import {
  DATAPOLICY,
  HELP,
  PAYWALL_REDIRECTION,
  PRIVACYPOLICY,
} from "./../../utilities/redirectorKeys";
import {
  getFullPaywallRedirectionUrl,
  disableAllScrolling,
  enableAllScrolling,
} from "./../../utilities/utils";
import SettingAbout from "./settingAbout";
import SettingAccount from "./settingaccount";
import SettingIFrame from "./settingIFrame";
import SettingLandscapeToggle from "./settingLandscapeToggle";
import SettingPreferredViewer from "./settingPreferredViewer";
import SettingRegion from "./settingRegion";
import { getVoucherEndDate, isVoucherActive } from "../../services/voucher";
import moment from "moment";
import SettingVoucher from "./settingVoucher";

export default class Setting extends Emitter {
  regionManager = null;
  sessionManager = null;
  paywall;
  options = null;
  disabledScrolling = [];

  // state when settings opened
  lastRegion = null;
  lastLoginChanged = false;

  constructor(appState, regionManager, sessionManager, paywall, options) {
    super();
    this._appState = appState;
    this.paywall = paywall;
    this.regionManager = regionManager;
    this.sessionManager = sessionManager;
    this.options = options;
    this.render();
    /*To avoid the browser to block window.open if it is not called in direct response to a user action*/
    this.fetchSettingsUrls();
  }

  render() {
    const context = {};
    context.i18n = language;
    context.close = true;
    context.settings = language.settings.title;
    context.region = language.region;
    context.username = this._appState.username;
    context.showCMP = this._appState.analyticsManager.cmpManager
      ? this._appState.analyticsManager.cmpManager._options.hasPreferenceView
      : false;
    context.settingclass =
      this._appState.analyticsManager.cmpManager &&
      this._appState.analyticsManager.cmpManager._options.settingClass
        ? this._appState.analyticsManager.cmpManager._options.settingClass
        : "";
    if (this.options.subscriptionOptions.subscriptionType !== "free") {
      context.showAccount = true;
      context.account = language.account;
      if (this._appState.isLoggedIn) {
        context.isLoggedIn =
          this._appState.username || language.accountLoggedIn;
      } else {
        context.isLoggedIn = language.accountLoggedOut;
        context.extraLogoutButtonClass = "hidden";
        context.isLoggedOut = true;
      }
    }
    context.help = language.help;
    context.about = language.about;
    context.SignOut = language.SignOut;
    const currentRegion = this.regionManager.getCurrentRegion();
    if (currentRegion) {
      context.currentRegion = currentRegion.Description;
    }
    context.displayViewerOptions = this.options.displayViewerOptions;
    context.preferredViewerLabel = this.getPreferredViewerLabel(
      this._appState.preferredViewer
    );
    context.isDesktop = this._appState.isDesktop;

    if (this._appState.isDesktop) {
      context.displayLandscapeToggle =
        this.options.replicaReadingModeToggle.desktop;
    } else {
      context.displayLandscapeToggle = this._appState.isTablet
        ? this.options.replicaReadingModeToggle.tablet
        : this.options.replicaReadingModeToggle.phone;
    }
    context.landscapeToggleLabel = this.getLandscapeToggleLabel(
      this._appState.isDoublePage
    );
    context.showLogoutButton =
      this._appState.isDesktop &&
      this.options.toggleSubscriptionTopNavButtonOnUserLoggedIn
        ? true
        : false;
    context.showPrivacyPolicy = this.options.showPrivacyPolicy;
    context.voucher = this._createVoucherContext();

    //render layout with context
    this.DOMContainer = document.querySelector("#settings");
    if (this.DOMContainer !== null) {
      Dust.render(setting, context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.attachEventHandlers();
      });
    }
  }

  _createVoucherContext() {
    const { isEnabled, dateFormat } = this.options.voucher;
    return {
      isEnabled,
      title: language.settings.voucher.title,
      extraText: isVoucherActive()
        ? `${language.settings.voucher.active} ${moment(
            getVoucherEndDate()
          ).format(dateFormat)}`
        : language.settings.voucher.inactive,
    };
  }

  fetchSettingsUrls() {
    APIManager.getRedirectorUrl(
      HELP,
      this._appState.buildVersion,
      this._appState.userId,
      this._appState.downloadToken
    )
      .then((result) => {
        this.helpurl = result;
      })
      .catch(() => {});

    if (
      this._appState.analyticsManager.cmpManager &&
      this._appState.analyticsManager.cmpManager._options.hasPreferenceView
    ) {
      APIManager.getRedirectorUrl(
        DATAPOLICY,
        this._appState.buildVersion,
        this._appState.userId,
        this._appState.downloadToken
      )
        .then((result) => {
          this.policyurl = result;
        })
        .catch(() => {});
    }

    if (this.options.showPrivacyPolicy) {
      APIManager.getRedirectorUrl(
        PRIVACYPOLICY,
        this._appState.buildVersion,
        this._appState.userId,
        this._appState.downloadToken
      )
        .then((result) => {
          this.privacyPolicyUrl = result;
        })
        .catch(() => {});
    }
  }

  attachEventHandlers() {
    const closeButton = this.DOMContainer.querySelector(
      ".overlay-navigation-close .overlay-navigation-icon"
    );
    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        this.onCloseButtonClick(e);
      });
    }

    const region = this.DOMContainer.querySelector(".settings-region");
    if (region) {
      region.addEventListener("click", (e) => {
        this.onRegionClick(e);
      });
    }

    const login = this.DOMContainer.querySelector(".settings-login");
    if (login) {
      login.addEventListener("click", (e) => {
        this.onLoginClick(e);
      });
    }

    if (this._appState.isDesktop) {
      const logOut = this.DOMContainer.querySelector(".settings-signOut");
      if (logOut) {
        logOut.addEventListener("click", (e) => {
          this.onLogoutClick(e);
        });
      }
    }

    const voucher = this.DOMContainer.querySelector(".settings-voucher");
    if (voucher) {
      voucher.addEventListener("click", (e) => {
        this.onVoucherClick(e);
      });
    }

    const help = this.DOMContainer.querySelector(".settings-help");
    if (help) {
      help.addEventListener("click", () => {
        this.onHelpClick(false);
      });
    }

    const about = this.DOMContainer.querySelector(".settings-about");
    if (about) {
      about.addEventListener("click", (e) => {
        this.onAboutClick(e);
      });
    }

    const preferredViewer = this.DOMContainer.querySelector(
      ".settings-preferred-viewer"
    );
    if (preferredViewer) {
      preferredViewer.addEventListener(
        "click",
        this.onPrefferedViewerClick.bind(this)
      );
    }

    const landscapeToggle = this.DOMContainer.querySelector(
      ".settings-landscape-toggle"
    );
    if (landscapeToggle) {
      landscapeToggle.addEventListener(
        "click",
        this.onLandscapeToggleClick.bind(this)
      );
    }

    const cmpSetting = this.DOMContainer.querySelector(".settings-cmp");
    if (
      cmpSetting &&
      !this._appState.analyticsManager.cmpManager._options.settingClass
    ) {
      cmpSetting.addEventListener("click", this.onCMPSettingClick.bind(this));
    }

    const policySetting = this.DOMContainer.querySelector(".settings-policy");
    if (policySetting) {
      policySetting.addEventListener("click", (e) => {
        this.onPolicySettingClick(e);
      });
    }

    const privacyPolicySetting = this.DOMContainer.querySelector(
      ".settings-privacypolicy"
    );
    if (privacyPolicySetting) {
      privacyPolicySetting.addEventListener("click", (e) => {
        this.onPrivacyPolicySettingClick(e);
      });
    }

    if (this._appState.isDesktop) {
      this._appState.on(
        "appState:isDoublePageChanged",
        this.updateSettingLandscapeToggle
      );
    }

    document.addEventListener("keyup", this.onKeyUpHandler);

    this.initListeners();
  }

  initListeners() {
    this._appState.on("appState:authenticationstatuschanged", () => {
      this.onAuthenticationStatusChanged();
    });
    this.regionManager.on("regionManager:regionChanged", () => {
      this.onRegionChanged();
    });
    this._appState.on(
      "preferredViewer:changed",
      this.preferredViewerChanged.bind(this)
    );
  }

  onAuthenticationStatusChanged() {
    const login = this.DOMContainer.querySelector(".settings-login-extra");
    const logout = this.DOMContainer.querySelector(".settings-signOut");
    if (login) {
      login.innerHTML = this._appState.isLoggedIn
        ? this._appState.username || language.accountLoggedIn
        : language.accountLoggedOut;
    }
    this.lastLoginChanged = true;
    if (logout) {
      if (this._appState.isLoggedIn) {
        logout.classList.remove("hidden");
      } else {
        logout.classList.add("hidden");
      }
    }
  }

  onCloseButtonClick(e) {
    e.stopPropagation();
    this.close();
    this._appState.triggerEvent(CLICKED_CLOSE_SETTINGS);
  }

  onRegionClick() {
    this.region = new SettingRegion(
      this._appState,
      this.regionManager,
      this.options
    );
    this.region.on("settingRegion:regionChanged", () => {
      this.onRegionChanged();
    });
    this.region.on("settingRegion:closed", () => {
      this.close();
    });
    this._appState.triggerEvent(CLICKED_REGIONSELECT_SETTINGS);
  }

  onRegionChanged() {
    const currentRegion = this.regionManager.getCurrentRegion();
    const region = this.DOMContainer.querySelector(".settings-region-extra");
    if (currentRegion && region) {
      region.innerHTML = currentRegion.Description;
    }
  }

  preferredViewerChanged(type) {
    const label = this.getPreferredViewerLabel(type);
    document.getElementById("preferred-viewer-extra").textContent = label;
  }

  onLoginClick() {
    if (!this._appState.isLoggedIn && this.options.paywallRedirectionUrl) {
      const number = CookieManager.getNumberOfRedirects();
      if (number >= this.options.externalPaywallMaxRedirectionNumber) {
        this._appState.triggerEvent(REACHED_REDIRECT_LIMIT);
        this.account = new SettingAccount(
          this._appState,
          this.paywall,
          this.options
        );
        this.account.on("settingAccount:closed", () => {
          this.close();
        });
      } else {
        APIManager.getUserProfileValue(PAYWALL_REDIRECTION)
          .then((result) => {
            if (
              result &&
              result[0] &&
              result[0].Value &&
              result[0].Value.length > 0
            ) {
              CookieManager.setNumberOfRedirects(
                number + 1,
                this.options.paywallRedirectionTimeReset
              );
              window.top.location.href = getFullPaywallRedirectionUrl(
                result[0].Value,
                this.paywall.authenticatorAuthorisationController,
                this.options
              );
            } else {
              this.account.on("settingAccount:closed", () => {
                this.close();
              });
            }
          })
          .catch(() => {
            this.account = new SettingAccount(
              this._appState,
              this.paywall,
              this.options
            );
            this.account.on("settingAccount:closed", () => {
              this.close();
            });
          });
      }
    } else {
      this.account = new SettingAccount(
        this._appState,
        this.paywall,
        this.options
      );
      this.account.on("settingAccount:closed", () => {
        this.close();
      });
    }
    this._appState.triggerEvent(CLICKED_ACCOUNT_SETTINGS);
  }

  onLogoutClick() {
    this.account = new SettingAccount(
      this._appState,
      this.paywall,
      this.options
    );
    this.account.onLogoutClick();
  }

  onVoucherClick() {
    this.voucher = new SettingVoucher(this._appState);
    this.voucher.on("settingVoucher:redeemed", () => {
      this.onVoucherRedeemed();
    });
    this.voucher.on("settingVoucher:goBack", () => {
      this.show();
    });
    this.voucher.on("settingVoucher:closed", () => {
      this.close();
    });
  }

  onVoucherRedeemed() {
    if (isVoucherActive()) {
      this.render();
    }
  }

  onHelpClick(isTopNavHelpButton = false) {
    if (!isTopNavHelpButton) {
      this._appState.triggerEvent(CLICKED_HELP_SETTINGS);
    }
    if (this._appState.isDesktop || this.options.openHelpOnNewtab) {
      this._openInNewtab(this.helpurl);
      return;
    }
    if (this.help && !this.help.isEmpty()) {
      this.help.show();
    } else {
      this.help = new SettingIFrame(
        this._appState,
        this.DOMContainer.querySelector("#sidemenu-help-container"),
        "help",
        language.help,
        this.helpurl,
        this.options
      );
      this.help.on("settingIframe:closed", () => {
        this.close();
      });
    }
  }

  onAboutClick() {
    if (this.about) {
      this.about.show();
    } else {
      this.about = new SettingAbout(
        this._appState,
        this.sessionManager,
        this.options.about
      );
      this.about.on("settingAbout:closed", () => {
        this.close();
      });
    }
    this._appState.triggerEvent(CLICKED_ABOUT_SETTINGS);
  }

  onLandscapeToggleClick() {
    const preferredViewerSetting = new SettingLandscapeToggle(this._appState);
    preferredViewerSetting.on(
      "settingLandscapeToggle:closed",
      this.close.bind(this)
    );
    preferredViewerSetting.on(
      "settingLandscapeToggle:changed",
      (chosenOption) => {
        const landscapeSettingValue = this.DOMContainer.querySelector(
          "#landscape-toggle-extra"
        );
        if (landscapeSettingValue) {
          if (chosenOption === "doublePage") {
            landscapeSettingValue.innerHTML = language.doublePageShort;
          } else {
            landscapeSettingValue.innerHTML = language.singlePageShort;
          }
        }
      }
    );
    preferredViewerSetting.render();
    this._appState.triggerEvent(CLICKED_LANDSCAPE_TOGGLE_SETTINGS);
  }

  onPrefferedViewerClick() {
    const preferredViewerSetting = new SettingPreferredViewer(this._appState);
    preferredViewerSetting.on(
      "settingPreferredViewer:closed",
      this.close.bind(this)
    );
    preferredViewerSetting.render();
    this._appState.triggerEvent(CLICKED_READING_MODE_SETTINGS);
  }

  hide() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.add("hidden");
    }
  }

  onSubscriptionButtonClick(e) {
    e.stopPropagation();
    this.subscription.show();
    this.trigger("setting:onReadingPreferenceButtonClick", e);
  }

  onReadingPreferenceButtonClick(e) {
    e.stopPropagation();
    this.readingPreference.show();
    this.trigger("setting:onSubscriptionButtonClick", e);
  }

  show() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.remove("hidden");
    }
  }

  open() {
    this.show();
    //keep state
    this.lastRegion = this._appState.downloadToken;
    this.lastLoginChanged = false;
    const region = this.DOMContainer.querySelector(".settings-region");
    if (region) {
      if (this.regionManager.singleRegion) {
        region.classList.add("hidden");
      } else {
        region.classList.remove("hidden");
      }
    }
    this.disabledScrolling = disableAllScrolling();
    this._appState.triggerEvent(OPENED_SETTINGS);
  }

  close() {
    this.hide();
    enableAllScrolling(this.disabledScrolling);
    if (this.lastRegion !== this._appState.downloadToken) {
      this.trigger("setting:onRegionChanged");
    }
    if (this.lastLoginChanged) {
      this.trigger("setting:onLoginChanged");
    }
  }

  getPreferredViewerLabel(type) {
    return type === "nextgen" ? language.DigitalVersion : language.PaperVersion;
  }

  getLandscapeToggleLabel(isDoublePage) {
    return isDoublePage ? language.doublePageShort : language.singlePageShort;
  }

  onKeyUpHandler = (e) => {
    if (e.which === 27) this.close();
  };

  onCMPSettingClick = (e) => {
    e.stopPropagation();
    this._appState.analyticsManager.cmpManager.showPreference();
  };

  onPolicySettingClick = (e) => {
    e.stopPropagation();
    if (this._appState.isDesktop || this.options.openPrivacyOnNewtab) {
      this._openInNewtab(this.policyurl);
      return;
    }
    if (this.policy && !this.policy.isEmpty()) {
      this.policy.show();
    } else {
      this.policy = new SettingIFrame(
        this._appState,
        this.DOMContainer.querySelector("#sidemenu-policy-container"),
        "policy",
        language.dataPolicy,
        this.policyurl,
        this.options
      );
      this.policy.on("settingIframe:closed", () => {
        this.close();
      });
    }
  };

  onPrivacyPolicySettingClick = (e) => {
    e.stopPropagation();
    if (this._appState.isDesktop || this.options.openPrivacyOnNewtab) {
      this._openInNewtab(this.privacyPolicyUrl);
    } else if (this.privacyPolicy && !this.privacyPolicy.isEmpty()) {
      this.privacyPolicy.show();
    } else {
      this.privacyPolicy = new SettingIFrame(
        this._appState,
        this.DOMContainer.querySelector("#sidemenu-privacypolicy-container"),
        "policy",
        language.privacyPolicy,
        this.privacyPolicyUrl,
        this.options
      );
      this.privacyPolicy.on("settingIframe:closed", () => {
        this.close();
      });
    }
  };

  _openInNewtab(url) {
    const newWindow = window.open(url, "_blank");
    newWindow.focus();
  }

  updateSettingLandscapeToggle = () => {
    const landscapeSettingValue = document.querySelector(
      "#landscape-toggle-extra"
    );
    if (landscapeSettingValue) {
      landscapeSettingValue.innerHTML = this._appState.isDoublePage
        ? language.doublePageShort
        : language.singlePageShort;
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/components/settings/setting.js